// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__39yrJ","navText":"Navbar_navText__IFGxS","navLogo":"Navbar_navLogo__2_Atc","imgLogo":"Navbar_imgLogo__3Xjr0"};